import { LocalPoi } from '../interface/LocalPoi';
import { LocalPoiFile } from '../interface/LocalPoiFile';

export const getPOI = async (auth: string): Promise<LocalPoi[] | string> => {
  const { REACT_APP_API_URL } = process.env;
  try {
    const response = await fetch(`${REACT_APP_API_URL}/localpoi/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: auth,
      },
    });

    const data = await response.json();

    if (response.ok) {
      return data.map((poi: LocalPoi) => ({
        id: poi.id,
        title: poi.title,
        description: poi.description,
        category: poi.category,
        longitude: poi.longitude,
        latitude: poi.latitude,
        files: poi.files?.map((file: LocalPoiFile) => ({
          id: file.id,
          name: file.name,
          description: file.description,
          downloadLink: file.file,
        })),
      }));
    } else {
      return data.message || 'Local POI fetch failed, are you signed in?';
    }
  } catch (error) {
    return (error as Error).message || 'Unknown error';
  }
};
